import './CustomDelimiter';
import './FieldMapping';
import './TargetFolder';
import {initImportWizard} from './Wizard';

const initializedWizards = new WeakSet();

export const initializeImportWizards = root => {
    root.querySelectorAll('[data-controller="import-wizard"]').forEach(wizard => {
        if (initializedWizards.has(wizard)) {
            return;
        }

        initializedWizards.add(wizard);

        initImportWizard(wizard);
    });
};
